var _dec, _class, _DiscoveryUnitRenderer;
import { inject } from 'mobx-react';
import React from 'react';
import { FunnelLogContextProvider } from '@udemy/funnel-tracking';
import { withI18n } from '@udemy/i18n';
import { udPerf } from '@udemy/performance-rum-client';
import { udSentry } from '@udemy/sentry';
import { ErrorBoundary } from '@udemy/shared-utils';
import { DiscoveryUnitsLoadingSkeleton } from './discovery-units-loading-skeleton.react-component';
/**
 * Receives a unit object and renders the appropriate unit.
 *
 * const unitTypes = [
    'bestseller',
    'bestseller_labels',
    'enroll_based',
    'most_viewed',
    'newest',
    'next_topics',
    'related_categories',
    'related_subcategories',
    'short_and_sweet',
    'view_based',
    'bundle',
    'algorithm_based_occupation'
];
const viewTypes = ['horizontal_tabbed', 'window_shopping', 'default'];
const itemTypes = ['course', 'course_label', 'instructor', 'category', 'subcategory', 'occupation'];
const memberOf = ['skills_hub_categories', 'skills_hub_top_new_beginner'];
 */
let DiscoveryUnitRenderer = (_dec = inject(stores => ({
  shouldSendPerfMetric: stores.shouldSendPerfMetric
})), _dec(_class = (_DiscoveryUnitRenderer = class DiscoveryUnitRenderer extends React.Component {
  constructor(...args) {
    super(...args);
    this.onLoad = () => {
      if (this.props.shouldSendPerfMetric) {
        udPerf.mark('udlite.first-unit-loaded');
      }
    };
  }
  render() {
    const {
      component: Component,
      componentProps,
      contextObject,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      captureException: udSentry.captureException
    }, /*#__PURE__*/React.createElement(FunnelLogContextProvider, Object.assign({
      pageType: this.props.pageType
    }, contextObject), /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, componentProps, {
      onLoad: this.onLoad,
      unit: this.props.unit
    }))));
  }
}, _DiscoveryUnitRenderer.defaultProps = {
  alternateHeadline: undefined,
  disableInfiniteScroll: false,
  fetchOptions: {},
  filter: () => true,
  itemCount: 12,
  itemIndicesByType: {},
  pageObject: {},
  pageObjectId: undefined,
  showTitle: true,
  skeletonComponent: DiscoveryUnitsLoadingSkeleton,
  store: undefined,
  units: [],
  componentProps: {},
  contextObject: {}
}, _DiscoveryUnitRenderer)) || _class);
const DiscoveryUnitRendererWithI18n = withI18n(DiscoveryUnitRenderer);
export { DiscoveryUnitRendererWithI18n as DiscoveryUnitRenderer };
//# sourceMappingURL=discovery-unit-renderer.react-component.js.map